import "./ShamrockMenuServices.scss";
import { Carousel } from "antd";
import CheckmarkIcon from "../icons/content-pages/CheckmarkIcon";

export default function ShamrockMenuServices() {
  function startChat() {
    Intercom('show');
  }

  return (
    <main className="shamrock-ms">
      <section className="one">
        <div className="content">
          <div className="flex">
            <div className="text">
              <img src="https://timber.mhmcdn.com/site/content/shamrock/menu-services/MHMxShamrockLogo.svg" alt="MustHaveMenus x Shamrock"/>
              <h1>Proud Menu Design Partner of Shamrock</h1>
              <h3>Give us your data. Get a menu fast.</h3>
              <div className="ant-btn ant-btn-primary" onClick={startChat}>Get Started</div>
            </div>
            <div className="img">
              <Carousel fade autoplay autoplaySpeed={5000} dots={false} pauseOnHover={false}>
                <div className="img-slide">
                  <img src="https://timber.mhmcdn.com/site/content/shamrock/menu-services/MenuHero.webp" alt="Menus"/>
                </div>
                <div className="img-slide">
                  <img src="https://timber.mhmcdn.com/site/content/shamrock/menu-services/DigiBoardHero.webp" alt="Digital Menu Boards"/>
                </div>
                <div className="img-slide">
                  <img src="https://timber.mhmcdn.com/site/content/shamrock/menu-services/OMHero.webp" alt="Ordering Menus"/>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </section>

      <section className="two gray-bg text-center">
        <div className="content">
          <h2>How It Works</h2>
          <div className="flex">
            <div className="item">
              <div className="img">
                <img className="ms-request" src="https://timber.mhmcdn.com/site/marketing/icons/MSRequest.svg" alt="Menu services request"/>
              </div>
              <h3>Submit a <br className="desktop-only"/>Menu Services request</h3>
              <p>Select your service, then complete the submission form</p>
            </div>
            <div className="item">
              <div className="img">
                <img src="https://timber.mhmcdn.com/site/marketing/icons/CustomerService.svg" alt="Customer service"/>
              </div>
              <h3>Connect with a <br className="desktop-only"/>menu expert</h3>
              <p>Once we've received your submission, we'll be in touch to confirm details and request payment</p>
            </div>
            <div className="item">
              <div className="img">
                <img src="https://timber.mhmcdn.com/site/marketing/icons/Calendar1-2.svg" alt="1 to 2 business days"/>
              </div>
              <h3>Get a menu within <br className="mobile-only"/>1-2 <br className="desktop-only"/>business days, or less</h3>
              <p>Our team will make the design available in your account, so you have complete access to the project</p>
            </div>
          </div>
          <div className="ant-btn ant-btn-primary" onClick={startChat}>Get Started</div>
        </div>
      </section>

      <section className="three text-center">
        <div className="content">
          <h2>Menu Services Pricing</h2>
          <p>Select Takeout Conversion, Pro Formatting, or Quick Build. All Menu Services project are ready for review in 1-2 business days after confirmation and receipt of payment.</p>
          <div className="flex">
            <div className="item takeout">
              <div className="price-card">
                <h3>Takeout<br/>Conversion</h3>
                <ul>
                  <li><CheckmarkIcon fill="#333"/><span>We'll create a matching takeout from a menu in your account</span></li>
                  <li><CheckmarkIcon fill="#333"/><span>Includes professional formatting</span></li>
                  <li><CheckmarkIcon fill="#333"/><span>Designed with your brand</span></li>
                </ul>
                <div className="btn-container">
                  <div className="ant-btn ant-btn-primary"><a href="https://forms.zohopublic.com/musthavemenus/form/TakeoutConversion/formperma/GGLalubgILPSiw7GLcZs78eXdLd6wvfLwnF1KpfNTN8" target="_blank" rel="noreferrer">Get Started</a></div>
                </div>
              </div>
              <div className="banner takeout">
                <span>$49</span><span>per menu</span>
              </div>
            </div>
            <div className="item pro">
              <div className="price-card">
                <h3>Pro<br/>Formatting</h3>
                <ul>
                  <li className="extra"><i>(limit of 4 single-sided pages)</i></li>
                  <li><CheckmarkIcon fill="#333"/><span>We'll change your menu design from one template to another or change page size or orientation</span></li>
                  <li><CheckmarkIcon fill="#333"/><span>Includes professional formatting</span></li>
                </ul>
                <div className="btn-container">
                  <div className="ant-btn ant-btn-primary"><a href="https://forms.zohopublic.com/musthavemenus/form/ProFormatting/formperma/zvBwE-5zloMOKtZKmoA5E9Cw_8G-IweGrEax5v2Ced8" target="_blank" rel="noreferrer">Get Started</a></div>
                </div>
              </div>
              <div className="banner pro">
                <span>$49</span><span>per menu</span>
              </div>
            </div>
            <div className="item quick">
              <div className="price-card">
                <h3>Quick<br/>Build</h3>
                <ul>
                  <li className="extra"><i><b>That's a 75% discount from<br/>our regular pricing</b></i></li>
                  <li><CheckmarkIcon fill="#333"/><span>We'll enter your menu data</span></li>
                  <li><CheckmarkIcon fill="#333"/><span>Includes professional formatting</span></li>
                  <li><CheckmarkIcon fill="#333"/><span>Designed with your brand and images</span></li>
                  <li><CheckmarkIcon fill="#333"/><span>Includes one round of revisions</span></li>
                  <li><CheckmarkIcon fill="#333"/><span>Fully editable menu once project is complete</span></li>
                </ul>
                <div className="btn-container">
                  <div className="ant-btn ant-btn-primary"><a href="https://forms.zohopublic.com/musthavemenus/form/MenuServicesRequest/formperma/iWWlpg_AON8izu5s_vgtGYaeVvnnOPu-UzdbJxa7nBg" target="_blank" rel="noreferrer">Get Started</a></div>
                </div>
              </div>
              <div className="banner quick">
                <span>$49</span><span>per single-sided page</span>
              </div>
            </div>
          </div>
          <div className="footnote">
            *Please note that for all Menu Services projects, the price does not include prints, custom menu design work, proofreading, revisions, or PDFs/image files. Payment and menu materials must be provided before your project can be started.
          </div>
        </div>
      </section>
    </main>
  )
}
